module.exports = __webpack_public_path__ + "static/media/aplicacao.92326757.png";